import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PasswordModalService } from "./password-modal.service";
@Component({
  selector: 'app-password-modal',
  templateUrl: './password-modal.component.html',
  styleUrls: ['./password-modal.component.scss']
})
export class PasswordModalComponent implements OnInit {
	modalType = "";
  constructor(
    public dialogRef: MatDialogRef<PasswordModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {},
    private _passwordModalService: PasswordModalService
  ) { }
  password = '';
  errorMessage = '';
  hide = false;

  ngOnInit(): void {
	  this.modalType = this.data['type']
  }

  onPasswordChange(event) {
    this.password = event.target.value;
  }

  setPassword() {
    if (this.password.length >= 8) {
      this.errorMessage = '';
      this.dialogRef.close({ templateId: this.data['id'], password: this.password })
    } else {
      this.errorMessage = 'Password must contain atleast 8 characters'
    }
  }

  checkPassword(): void {
    this.errorMessage = "";
    if (this.password.length > 0) {
      this._passwordModalService.checkPassword(this.password, this.data["templateId"]).subscribe((response) => {
        if (response["success"]) {
          this.dialogRef.close();
        } else {
          this.errorMessage = "Password didn't match";
        }
      }, (error) => {
        console.log(error);
        this.errorMessage = "Server side error occurred. Please try again later."
      });
    } else {
      this.errorMessage = "Enter password to proceed";
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
